import { FEEDBACK, FEEDBACK_CLEAR, FEEDBACK_LOADING } from "../types/feedback";

const initialState = {
  loading: false,
  status: "",
  message: "",
};

const feedbackReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FEEDBACK:
      return { ...state, loading: payload.loading, status: payload.status, message: payload.message };
    case FEEDBACK_LOADING:
      return { ...state, loading: payload };
    case FEEDBACK_CLEAR:
      return { ...state, loading: false, message: "", status: "" };
    default:
      return state;
  }
};

export default feedbackReducer;
